import type { Rule } from "../types";
import { makeFiring } from "../util";

const EVIDENCE = "walker_2017_rem_consolidation";

/**
 * Two consecutive nights below 6 hours total sleep. Walker 2017's review
 * compiles the cognitive + immune costs of acute sleep restriction; two
 * sub-6h nights is the threshold beyond which next-day cognitive consolidation
 * tasks degrade measurably.
 */
export const sleepDebt2Nights: Rule = {
  id: "sleep_debt_2nights",
  domain: "health.recovery",
  topics: ["sleep", "duration"],
  evidence_refs: [EVIDENCE],
  title: () => "Two short nights",
  evaluate(ctx) {
    const sortedDesc = [...ctx.vitals].sort((a, b) => (a.date < b.date ? 1 : -1));
    const last2 = sortedDesc.slice(0, 2);
    if (last2.length < 2) return null;
    const minutes = last2.map((r) => r.sleep_min);
    if (minutes.some((m) => m == null)) return null;
    const both = minutes.map((m) => (m as number) / 60);
    if (!both.every((h) => h < 6)) return null;
    const avg = (both[0] + both[1]) / 2;
    return makeFiring({
      rule_id: "sleep_debt_2nights",
      now: ctx.now,
      tz: ctx.tz,
      severity: "warn",
      message: `Two nights averaging ${avg.toFixed(1)}h. Cognitive consolidation drops measurably below 6h.`,
      evidence_refs: [EVIDENCE],
      factors: [
        {
          name: "avg_sleep_h",
          value: Number(avg.toFixed(1)),
          contribution: "earlier bedtime tonight",
          evidence_ref: EVIDENCE,
        },
      ],
      target_surface: "health.recovery",
    });
  },
};
